import { render } from "./AddShopFooter.vue?vue&type=template&id=6e4ad50e&ts=true"
import script from "./AddShopFooter.vue?vue&type=script&lang=ts"
export * from "./AddShopFooter.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\Hermelin\\hermelinshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__